import { FavoriteButton } from "@/components/vitrine/components/Favorite-button"
import { MidiaProdutoVitrine } from "@/components/vitrine/components/MidiaProdutoVitrine"
import type { Produto } from "@/components/vitrine/types/produto.props"
import { isDev } from "@/utils/enviroment-detector"
import { priceFormatter } from "@/utils/formatter"
import { getLinkProduto } from "@/utils/getLinkProduto"
import { getResourceFromS3 } from "@/utils/getResourceFromS3"
import { useCountdown } from "@/utils/useCountdown"
import { zordDbDatetimeToStr } from "@/utils/zordDbDatetimeToStr"

interface ItemOfertaProps {
    hostImagem: string
    produto: Produto
    precoPrincipal: number
    exibeValoresSomenteLogado: boolean
    zordHintLoading: string
    width: number
    height: number
    hoverImagensVitrine: boolean
    hoverImagensVitrineMobile: boolean
    utilizaFavoritosVitrine: boolean
    vitrineButtonAddToCart: string
}

export function ItemOferta({
    hostImagem,
    produto,
    precoPrincipal,
    exibeValoresSomenteLogado,
    zordHintLoading,
    width,
    height,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine,
    vitrineButtonAddToCart
}: ItemOfertaProps){
    let precoItem = 0
    let percentualDescontoItem = 0

    if (precoPrincipal == 1 && produto.valor_boleto && produto.valor_boleto > 0) {
        precoItem = produto.valor_boleto
        if (produto.valor_de && produto.valor_de > 0) {
            percentualDescontoItem = (100 - (produto.valor_boleto / produto.valor_de * 100))
        }
    } else if (precoPrincipal == 2 && produto.valor_cartao && produto.valor_cartao[0] > 0) {
        precoItem = produto.valor_cartao[5] ? produto.valor_cartao[5].valor : produto.valor_cartao[1]
        if (produto.valor_de && produto.valor_de > 0) {
            percentualDescontoItem = (100 - (precoItem / produto.valor_de * 100))
        }
    } else if (precoPrincipal == 4 && produto.valor_pix && produto.valor_pix > 0){
        precoItem = produto.valor_pix
        if (produto.valor_de && produto.valor_de > 0) {
            percentualDescontoItem = (100 - (produto.valor_pix / produto.valor_de * 100))
        }
    }

    const hasDiscount = Boolean(produto.valor_de && produto.valor_de > precoItem)
    const hasPrice = precoItem > 0

    const { dias, horas, minutos, segundos } = useCountdown(produto.data_fim)

    return (
        exibeValoresSomenteLogado ? (
            <div className="item-oferta center flex">
                <div className="box-img-item">
                    <a href={getLinkProduto(produto)}>
                        <figure className={`${utilizaFavoritosVitrine ? 'has-favorite-button' : ''}`}>
                            <MidiaProdutoVitrine
                                hostImagem={hostImagem}
                                produto={produto}
                                width={width}
                                height={height}
                                hoverImagensVitrine={hoverImagensVitrine}
                                hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                            />

                            {utilizaFavoritosVitrine && <FavoriteButton produto={produto} />}
                        </figure>
                    </a>
                </div>
                <div className="box-info-item">
                    <a href={getLinkProduto(produto)}>
                        <h3 className="title-item">{produto.nome}</h3>
                    </a>

                    <div className="valores-logados-vitrine">
                        <span>
                            Faça login para ver os preços
                        </span>

                        <a
                            href={`/login?redir=${encodeURIComponent(globalThis.window.location.href)}`}
                            className="btn-comprar-vitrine flex center justify-center"
                        >
                            Fazer login
                        </a>
                    </div>
                </div>
            </div>
        ) : (
            <a href={getLinkProduto(produto)}>
                <div className="item-oferta center flex">
                    <div className="box-img-item">
                        <figure className={`${utilizaFavoritosVitrine ? 'has-favorite-button' : ''}`}>
                            <MidiaProdutoVitrine
                                hostImagem={hostImagem}
                                produto={produto}
                                width={width}
                                height={height}
                                hoverImagensVitrine={hoverImagensVitrine}
                                hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                            />

                            {utilizaFavoritosVitrine && <FavoriteButton produto={produto} />}
                        </figure>
                    </div>
                    <div className="box-info-item">
                        {hasDiscount && (
                            <span className="tag-desconto">
                                <span className="icon-tag">
                                    <img
                                        className="lazyload lazyload-svg"
                                        src={isDev() ? getResourceFromS3('assets/global/blackfriday', 'fire.svg') : zordHintLoading}
                                        data-src={getResourceFromS3('assets/global/blackfriday', 'fire.svg')}
                                        alt="Desconto"
                                        width="16"
                                        height="16"
                                    />
                                </span>
                                <span className="tag-off">{Math.round(percentualDescontoItem)}% OFF</span>
                            </span>
                        )}
                        <h3 className="title-item">{produto.nome}</h3>
                        <div className="box-price-timer">
                            <div className="box-price">
                                {hasDiscount && (
                                    <span className="old-price-item">De: {priceFormatter.format(produto.valor_de)}</span>
                                )}
                                {hasPrice && (
                                    <span className="price-item">Por: {priceFormatter.format(precoItem)}</span>
                                )}
                            </div>

                            {produto.data_fim && (
                                <div className="countdown-oferta tipo clearfix" data-fim={zordDbDatetimeToStr(produto.data_fim)} data-diff-days="true">
                                    <div className="alinha-contador flex">
                                        <div className="ctn dia flex column">
                                            <span className="count">{dias}</span>
                                            <span className="text">Dias</span>
                                        </div>
                                        <div className="ctn hora flex column">
                                            <span className="count">{horas}</span>
                                            <span className="text">Hr</span>
                                        </div>
                                        <div className="ctn min flex column">
                                            <span className="count">{minutos}</span>
                                            <span className="text">Min</span>
                                        </div>
                                        <div className="ctn seg flex column">
                                            <span className="count">{segundos}</span>
                                            <span className="text">Sec</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="button button-full button-buy">{vitrineButtonAddToCart}</div>
                    </div>
                </div>
            </a>
        )
    )
}